import React, { useEffect, useRef } from "react";
import { Card } from "react-bootstrap";
import DataLoader from "../Spinner/DataLoader";
import styles from "./ProfileDiv.module.css";
import { BASE_URL } from "../../constants";
import { useUserStore } from "../../store/useUserStore";
import axiosInstance from "../../utils/axiosInstance";

const ProfileDiv = () => {
  const { user, imageUrl, isReady, loadUser, updateImage, setImageUrl } = useUserStore();

  const fileRef = useRef();
  const token = localStorage.getItem("teacher_authToken") || localStorage.getItem("authToken");

  useEffect(() => {
    if (token) loadUser();
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectImage = async (e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith("image/")) return;

    setImageUrl(URL.createObjectURL(file));

    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await axiosInstance.post(BASE_URL + "/files/upload-profile-photo", formData);
      const json = res.data;

      if (json.fileUuidName) {
        updateImage(json.fileUuidName, json.id);
      }

      window.dispatchEvent(new CustomEvent("api-success", { detail: { message: "Şəkil uğurla yükləndi" } }));
    } catch (err) {
      console.error("Şəkil upload xətası:", err);
    }
  };

  return (
    <Card
      className={`text-center p-4 p-md-5 ${styles.card}`}
      style={{ position: "relative" }}
    >
      <DataLoader show={!isReady} />
      {isReady && user && (
        <>
          <div className={styles.avatarWrapper}>
            <img src={imageUrl} alt="avatar" className={styles.avatar} />
            <div onClick={() => fileRef.current.click()} className={styles.uploadIcon}>
              <i className="bi bi-camera"></i>
            </div>
            <input
              ref={fileRef}
              type="file"
              hidden
              accept="image/*"
              onChange={handleSelectImage}
            />
          </div>
          <Card.Body className={styles.cardBody}>
            <Card.Title className={styles.cardTitle}>
              {user.name} {user.surname}
            </Card.Title>
            <Card.Text className={styles.username}>@{user.username}</Card.Text>
            <Card.Text className={styles.status}>
              {user.userType === "teacher" ? "Müəllim" : user.userType}
            </Card.Text>
          </Card.Body>
        </>
      )}
    </Card>
  );
};

export default ProfileDiv;
